import type { ReactNode } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import type CommandeArticleHistory from "models/CommandeArticleHistory";
import CommandeHistoryList from "./CommandeHistoryList/CommandeHistoryList";

interface CommandeHistoryProps {
  historyCommandes: Array<CommandeArticleHistory>;
}

function CommandeHistory({ historyCommandes }: Readonly<CommandeHistoryProps>): ReactNode {
  return (
    <Grid container component={Paper} variant="outlined" sx={{ p: 2 }} size={12}>
      <Grid size={12}>
        <Typography variant="subtitle1" color="primary">
          Historique de l'agent
        </Typography>
        <Typography variant="caption">Sur 5 ans</Typography>
      </Grid>
      <Grid size={12}>
        <CommandeHistoryList history={historyCommandes} />
      </Grid>
    </Grid>
  );
}

export default CommandeHistory;
